// extracted by mini-css-extract-plugin
module.exports = {"statePeopleContainer":"styles_statePeopleContainer__4_mdu","statePeopleLabel":"styles_statePeopleLabel__2NAWo","statePeopleInput":"styles_statePeopleInput__1SLLF"};